import axios from "../axios-auth";

export const discountService = {
    getDiscounts,
    saveDiscount,
    getDiscountDetail,
    getAllDiscounts,
    getDiscountByStatus,
    getDiscountByStatusAndDiscountType
};

function getDiscounts(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };


    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/discounts", { params });
}

function getAllDiscounts() {

    return axios.get("/auth/discounts", {});
}

function saveDiscount(discount) {
    if (!discount.id) {
        // new customer
        return axios.post("/auth/discount", discount);
    } else {
        // edit
        return axios.put("/auth/discount", discount);
    }
}

function getDiscountDetail(id) {
    return axios.get("/auth/discount/" + id);
}

function getDiscountByStatus(status) {
    return axios.get("/auth/discounts-by-status/" + status);
}

function getDiscountByStatusAndDiscountType(status, discountType) {
    let params = {};

    if (status) {
        params["status"] = status;
    }

    if (discountType) {
        params["discountType"] = discountType;
    }
    return axios.get("/auth/discounts-by-status-and-discountType", { params });
}
